import { Howl } from "howler";
import React, { useState, useEffect, useRef } from "react";
import "./BonoboHopeKeyboard.css";

const audioSprites = {
	"A": [151, 627],
	"AFrame": [789, 801],
	"Agree": [1606, 1129],
	"All": [2744, 737],
	"Alpha": [435745, 444],
	"Am": [4005, 883],
	"Amanda": [4913, 834],
	"And": [5887, 903],
	"Apple":	[6908, 511],
	"Apricot":	[7466, 874],
	"Are":	[8444, 712],
	"Arm":	[9180, 720],
	"Ask": [445973, 546],
	"Austin":	[10207, 846],
	"Away":	[11065, 940],
	"Baby":	[12145, 794],
	"Back":	[12939, 632],
	"Backpack":	[13571, 916],
	"Bad":	[14652, 857],
	"Ball":	[15533, 825],
	"Balloon":	[16370, 963],
	"Banana":	[17349, 818],
	"Bark":	[18167, 645],
	"Bathroom":	[18820, 827],
	"Be":	[19754, 1066],
	"Bedroom":	[20820, 873],
	"Before":	[21693, 1170],
	"Beta": [437022, 467],
	"Big":	[23013, 637],
	"Bill":	[23674, 866],
	"Bird":	[24550, 708],
	"Bite":	[25542, 546],
	"Blackberries":	[26088, 1346],
	"Blackboard":	[27547, 1002],
	"Blanket":	[28783, 1472],
	"Blue":	[30255, 1206],
	"Blueberry":	[31461, 1617],
	"Book":	[33104, 600],
	"Bottom":	[33904, 622],
	"Bowl":	[34695, 839],
	"Box":	[35578, 737],
	"Bread":	[36739, 780],
	"Break":	[37564, 566],
	"Broken":	[38130, 738],
	"Brush":	[39092, 817],
	"Bubbles":	[39942, 994],
	"Bug":	[40981, 470],
	"Bunny":	[41496, 911],
	"Burrito":	[42407, 954],
	"Butter":	[43361, 542],
	"Cabinet":	[43903, 907],
	"Camera":	[44810, 931],
	"CamperCabin":	[45741, 1407],
	"Can":	[47155, 929],
	"Candy":	[48186, 903],
	"CanOpener":	[49089, 1225],
	"Car":	[50314, 795],
	"Careful":	[51130, 1393],
	"Carrot":	[52645, 778],
	"Carry":	[53423, 828],
	"Celery":	[54251, 1016],
	"Cereal":	[55388, 1019],
	"Chalk":	[56507, 786],
	"Chase":	[57293, 746],
	"Cheese":	[58039, 1301],
	"Cherries":	[59385, 1078],
	"Chicken":	[60648, 656],
	"Childside":	[61564, 1255],
	"Chips":	[63053, 647],
	"Chow":	[63745, 702],
	"Clara":	[66688, 815],
	"Clay":	[67604, 781],
	"Clippers":	[68405, 792],
	"Close":	[69240, 948],
	"Clover":	[70232, 1297],
	"Coconut":	[71583, 973],
	"Coffee":	[72604, 623],
	"Coke":	[73284, 569],
	"Cold":	[74243, 1127],
	"Collar":	[75508, 710],
	"ColonyRoom":	[76262, 1081],
	"Color":	[77635, 772],
	"Come":	[78440, 671],
	"Conversation": [444661, 1126],
	"Cooler":	[79347, 674],
	"Count":	[80191, 523],
	"Crayon":	[80784, 849],
	"CrisscrossCorners":	[64456, 2131],
	"Delta": [438148, 1115],
	"Dessert":	[81633, 1200],
	"Different":	[82859, 1254],
	"Dig":	[84158, 611],
	"Do":	[84776, 790],
	"Dog":	[85611, 1000],
	"Dont": [447355, 522],
	"Down":	[86786, 921],
	"Downstairs":	[87751, 1449],
	"Draw":	[89250, 834],
	"Drink":	[90185, 715],
	"Duane":	[90900, 803],
	"Ear":	[91748, 679],
	"Easy":	[92471, 919],
	"Eat":	[93420, 640],
	"edPast": [440818, 522],
	"Egg":	[94221, 685],
	"ElectricShock":	[94942, 1448],
	"Elikia":	[96442, 831],
	"Epsilon": [439332, 1416],
	"Fast":	[97549, 700],
	"Feel":	[98268, 1168],
	"Fight":	[99436, 534],
	"Fire":	[100008, 650],
	"Fish":	[100701, 836],
	"Five":	[101750, 754],
	"Flatrock":	[102697, 865],
	"Food":	[103901, 750],
	"Foot":	[104659, 637],
	"For":	[105296, 821],
	"Four":	[106117, 683],
	"Fridge":	[106800, 784],
	"Fruit":	[107584, 790],
	"Gamma": [438169, 469],
	"Gaila":	[108374, 759],
	"Get":	[109133, 590],
	"Give":	[109723, 780],
	"Go":	[110608, 843],
	"Good":	[111451, 1536],
	"Goodbye":	[112987, 1047],
	"Gorilla":	[114143, 844],
	"Grab":	[114989, 639],
	"Grapes":	[115680, 990],
	"Green":	[116686, 812],
	"GreenBean":	[293140, 1277],
	"GroupRoom": [426004, 848],
	"Groom":	[294654, 909],
	"GullyGusher":	[295563, 1056],
	"Had":	[296743, 615],
	"Hamburger":	[297795, 743],
	"Hammer":	[298709, 625],
	"Hand":	[299481, 894],
	"Happy":	[300496, 627],
	"Hat":	[302073, 441],
	"Have":	[301183, 731],
	"Head":	[302830, 569],
	"Heather":	[303606, 848],
	"Heidi":	[304616, 755],
	"Hello":	[305426, 673],
	"Here":	[306277, 523],
	"Hide":	[306933, 616],
	"Hilltop":	[307695, 697],
	"Honeysuckle":	[308721, 906],
	"Hose":	[309847, 846],
	"Hot":	[311046, 580],
	"Hotdog":	[311703, 871],
	"House":	[312653, 801],
	"How":	[313479, 755],
	"Hug":	[314296, 797],
	"Hurt":	[315155, 709],
	"I":	[315904, 862],
	"Ice":	[316766, 641],
	"If":	[317488, 508],
	"In":	[318245, 619],
	"Ing":	[441434, 662], 
	"Ing2": [318864, 688],
	"Is":	[319846, 927],
	"It":	[320874, 621],
	"Jared":	[321495, 562],
	"Jello":	[322339, 642],
	"Jelly":	[323081, 586],
	"Jenasi":	[323914, 960],
	"Jon":	[325100, 839],
	"Jordan":	[325939, 636],
	"Joystick":	[326755, 892],
	"Juice":	[327924, 786],
	"Julie":	[328800, 650],
	"Jump":	[329554, 546],
	"June":	[330440, 870],
	"Kanzi": [425157, 766],
	"Karen":	[331412, 654],
	"Kali": [332198, 647],
	"Kari":	[332198, 647],
	"Kate":	[332846, 706],
	"KeepAway":	[333773, 816],
	"Key":	[334841, 624],
	"Keyboard":	[335465, 683],
	"Kirk":	[336650, 646],
	"Kiss":	[337296, 834],
	"Kiwi":	[338229, 915],
	"Knife":	[339144, 480],
	"Koolaid":	[339849, 763],
	"Lana":	[340688, 930],
	"Later":	[341661, 859],
	"Leaf":	[429127, 998],
	"Lemon":	[344293, 672],
	"Lemonade":	[345103, 1140],
	"Lettuce":	[346243, 1044],
	"Lever":	[347336, 767],
	"Light":	[348130, 877],
	"Lighter":	[349141, 801],
	"Like":	[350071, 1087],
	"Linda":	[351172, 873],
	"Lindsay":	[352089, 918],
	"Listen":	[353063, 810],
	"Little":	[354006, 788],
	"Liz":	[354922, 1122],
	"LogCabin":	[356157, 1221],
	"Look":	[357418, 569],
	"LookoutPoint":	[358051, 1300],
	"Mad":	[360293, 986],
	"Mad1":	[359397, 825],
	"Magnet":	[361279, 854],
	"Maisha":	[362284, 917],
	"Make":	[363390, 656],
	"Many":	[364129, 846],
	"Mary": [430184, 766],
	"Marshmallow":	[364975, 1353],
	"MandMs": [424170, 940],
	"Mask":	[366604, 940],
	"Matata":	[367556, 899],
	"Me":	[369436, 868],
	"Me1":	[368482, 923],
	"Medicine":	[370425, 1068],
	"Melon":	[371599, 871],
	"MiddleTestRoom":	[372532, 1356],
	"Midway":	[374004, 906],
	"Milk":	[375229, 592],
	"Mine":	[375891, 830],
	"Mirror":	[377315, 778],
	"Money":	[378178, 754],
	"Monster":	[378934, 1086],
	"More":	[380090, 708],
	"Mouth":	[380818, 795],
	"Mushroom":	[381648, 1078],
	"MushroomTrail":	[382795, 1303],
	"Music":	[384153, 976],
	"My":	[385397, 817],
	"Nails":	[386275, 1089],
	"NasaBuilding":	[387550, 1225],
	"Natalie":	[389027, 912],
	"Nathan":	[389989, 648],
	"Need":	[391071, 949],
	"Neema":	[392295, 760],
	"Nest":	[393145, 808],
	"New":	[393958, 815],
	"Night":	[394810, 978],
	"No":	[397426, 762],
	"No1":	[395819, 708],
	"No2":	[396539, 843],
	"Noise":	[398267, 955],
	"Noodles":	[426991, 917],
	"Not":	[400250, 699],
	//"Now":	[400999, 648],
	"Now":	[401718, 692],
	"Nyota":	[402474, 746],
	"ObservationRoom":	[403288, 1283],
	"Off":	[404746, 430],
	"Oil":	[405419, 569],
	"On":	[406054, 714],
	"One":	[406833, 764],
	"Onion":	[407623, 661],
	"Open":	[409080, 776],
	"Open1":	[408352, 638],
	"Orange":	[410014, 738],
	"OrangeDrink":	[410777, 1013],
	"OrangeJuice":	[411857, 1190],
	"Orangutan":	[413107, 1195],
	"Out":	[414330, 622],
	"Outdoors":	[415767, 1049],
	"Paint":	[416871, 487],
	"Panbanisha":	[417518, 1313],
	"Panzee":	[418856, 873],
	"Paper":	[419793, 669],
	"Peaches":	[420570, 969],
	"Peanut":	[421581, 696],
	"Pear":	[422428, 558],
	"Peas": [423042, 871],
	"Pee":	[117642, 682],
	"Period":	[118324, 753],
	"Perrier":	[119093, 859],
	"Phone":	[119973, 797],
	"Picture":	[120770, 818],
	"Piece":	[121588, 877],
	"Pillow":	[122465, 788],
	"Pineapple":	[123432, 897],
	"Pinecone":	[124353, 906],
	"PineNeedle":	[125281, 1002],
	"Pinky":	[126391, 998],
	"Place":	[127412, 778],
	"PlasticBag": [431182, 1173],
	"Play":	[129639, 1054],
	"Play1":	[128312, 1222],
	"PlayYard":	[130793, 877],
	"Please":	[131807, 1293],
	"PluralS":	[442142, 615],
	"Point":	[133111, 630],
	"Pomegranate":	[133755, 1137],
	"Popsicle":	[134892, 1138],
	"Potato":	[136131, 1028],
	"Pour":	[137204, 1018],
	"Pout":	[415013, 618],
	"Pretend":	[138222, 1076],
	"Privet":	[139328, 738],
	"PrivetBush":	[140066, 966],
	"PSuke":	[141067, 1163],
	"Push":	[142230, 940],
	"Put":	[143170, 952],
	"Puzzle":	[144122, 759],
	"Question":	[144881, 1073],
	"Quiet":	[145986, 1382],
	"Quiz":	[147447, 898],
	"Radio":	[148664, 1053],
	"Rain":	[149743, 1415],
	"Raisin":	[151167, 720],
	"Ready":	[151936, 603],
	"Red":	[152619, 559],
	"Right":	[153178, 1317],
	"River":	[154495, 795],
	"Rob":	[155290, 868],
	"Rock":	[156164, 581],
	"RubberBand":	[156908, 995],
	"Run":	[157903, 755],
	"Said":	[158658, 953],
	"Salt":	[159728, 790],
	"Same":	[160550, 855],
	"Sandpile":	[161438, 970],
	"Sara": [432436, 778],
	"Sarah": [432436, 778],
	"Say":	[162566, 1277],
	"Scare":	[163898, 779],
	"ScrubbyPineNook":	[164704, 1441],
	"Secret":	[166145, 1694],
	"See":	[167839, 843],
	"Sherman":	[168703, 1092],
	"Shirt":	[169826, 836],
	"Shoe":	[170674, 968],
	"Shop":	[171751, 814],
	"Shot":	[172565, 962],
	"Show":	[173528, 999],
	"Sick":	[174527, 1343],
	"Sit":	[175870, 1017],
	"Slap":	[176908, 1033],
	"Sleep":	[178132, 1619],
	"Slow":	[179751, 1412],
	"Smell": [443106, 848],
	"Snake":	[181192, 819],
	"Soap":	[182497, 824],
	"Some":	[183343, 1139],
	"Sorry":	[184515, 1249],
	"SourCream":	[185872, 1081],
	"Sparkler":	[186953, 968],
	"Sponge":	[188146, 1098],
	"Spoon":	[189259, 1120],
	"Squirrel":	[190406, 720],
	"StaffOffice":	[191206, 1068],
	"Stethoscope":	[192312, 1310],
	"Steve":	[193793, 1158],
	"Stick":	[194951, 838],
	"Stop1":	[195800, 1075],
	"Stop2":	[197125, 1110],
	"Stop3":	[198235, 1064],
	"Straw":	[199399, 1060],
	"Strawberries":	[200632, 1857],
	"String":	[202489, 858],
	"Sue":	[203347, 873],
	"SuesGate":	[204220, 1025],
	"SuesOffice":	[205245, 1208],
	"Sugar":	[206453, 1240],
	"SugarCane":	[207693, 1381],
	"Surprise":	[209249, 1746],
	"SweetPotato":	[210995, 1601],
	"Swelling":	[212736, 1010],
	"SwimmingPool":	[213770, 1605],
	"Taco":	[216360, 705],
	"Take":	[217065, 771],
	"Talk":	[217927, 648],
	"Tamuli":	[219446, 815],
	"Tamuli1":	[218575, 766],
	"Taste": [444011, 580],
	"Tea":	[220698, 680],
	"Teco":	[221378, 857],
	"Ted":	[222390, 629],
	"ThankYou":	[223064, 1300],
	"That":	[224364, 798],
	"The":	[225162, 945],
	"Then":	[226203, 917],
	"There":	[227260, 638],
	"Thermometer":	[228219, 881],
	"These":	[229112, 1284],
	"Thing":	[230396, 649],
	"Think":	[231255, 578],
	"This":	[231966, 766],
	"Three":	[232744, 1503],
	"Throw":	[234251, 956],
	"Tickle":	[235210, 624],
	"Time":	[235835, 956],
	"To":	[236791, 719],
	"Today":	[237750, 1021],
	"Tomato":	[238987, 822],
	"Tomorrow":	[239849, 1160],
	"ToolRoom":	[241015, 816],
	"Toothbrush":	[241835, 972],
	"Toothpaste":	[242807, 1032],
	"Touch":	[243907, 770],
	"Towel":	[244712, 817],
	"Toy":	[245529, 655],
	"Trailer":	[246296, 685],
	"Trash":	[246988, 896],
	"Tree":	[343612, 641],
	"TreeHouse":	[247884, 942],
	"TRoom":	[215375, 985],
	"Try":	[248836, 1060],
	"Tummy":	[249896, 522],
	"Turtle":	[250566, 621],
	"TV":	[251344, 1093],
	"TVTape":	[252441, 1184],
	"Two":	[253630, 739],
	"Umbrella":	[254369, 794],
	"Until":	[255326, 894],
	"Up":	[256379, 524],
	"Vacuum":	[257090, 1007],
	"Vegetable":	[258440, 1090],
	"Vegetables":	[259781, 1262],
	"VelvetPlant":	[261489, 1124],
	"Video":	[262718, 791],
	"Visitors":	[263546, 979],
	"Vitamin":	[264553, 847],
	"Volunteer":	[265500, 1031],
	"Wait":	[266725, 1090],
	"Walk":	[267815, 627],
	"Want":	[269584, 1016],
	"Want1":	[268493, 972],
	"Warm": [447993, 708],
	"Was":	[270600, 1116],
	"Wash":	[271716, 1014],
	"Water":	[272751, 873],
	"Watermelon":	[276014, 1637],
	"Watermelon1":	[273638, 1180],
	"Watermelon2":	[274818, 1165],
	"We":	[277876, 746],
	"Whaa":	[182030, 453],
	"What":	[278668, 705],
	"Where":	[279373, 687],
	"Will":	[280258, 905],
	"Wipies":	[281183, 1022],
	"With":	[282236, 837],
	"Work": [283073, 864],
	"Wrong":	[283937, 1135],
	"Yellow":	[285139, 740],
	"Yes":	[285881, 938],
	"Yesterday":	[286819, 1229],
	"Yogurt":	[289070, 1024],
	"Yogurt1":	[288148, 909],
	"You":	[290098, 906],
	"Your":	[291010, 973],
	"Yours":	[291990, 1065]
};

const panels = [
    {
      id: 1,
      name: "Panel 1",
      topKeys: ["One", "Two", "Three", "Four", "Five"],
      keys: [
        ["SweetPotato", "Tickle", "Orange", "Nathan", "Trailer", "Peanut",
         "Car", "Raisin", "Hamburger", "Sherman", "Egg", "Dig", "Kanzi", "Austin",
         "Fridge", "Sandpile"],
        ["Ball", "Childside", "Melon", "Coffee", "Question", "Jelly", "SuesOffice",
         "Groom", "LogCabin", "Chow", "Stick", "SourCream", "Rain", "Clover", "Lever",
         "Lemonade"],
        ["Sue", "Tomato", "Go", "Clara", "Banana", "AFrame", "Outdoors", "Bill",
         "Fire", "TV", "Rock", "SuesGate", "Carrot", "MushroomTrail", "MandMs",
         "Umbrella"],
        ["ColonyRoom", "Food", "Cherries", "OrangeDrink", "Key", "Open", "Yes",
         "Milk", "Hotdog", "Burrito", "CrisscrossCorners", "Blackberries",
         "Butter", "VelvetPlant", "Money", "Flatrock"],
        ["Pee", "Apple", "GroupRoom", "Peaches", "Light", "PlayYard", "Orangutan",
         "No", "CanOpener", "PineNeedle", "Ice", "RubberBand", "LookoutPoint",
         "GreenBean", "CamperCabin", "Matata"],
        ["Liz", "Dog", "Bedroom", "OrangeJuice", "Coke", "Bite", "Bread", "Hug",
         "Water", "Straw", "Hide", "Shot", "String", "Pinecone", "Gone", "Grab"],
        ["Chase", "StaffOffice", "Juice", "Collar", "Blanket", "Cheese", "Hose",
         "Get", "Jump", "Turtle", "Goodbye", "Hello", "Lemon", "GullyGusher",
         "Bark", "Surprise"],
        ["Talk", "Keyboard", "Sleep", "Celery", "Apricot", "Stethoscope",
         "Hurt", "Look", "TreeHouse", "Come", "Midway", "Magnet", "ScrubbyPineNook",
         "NasaBuilding", "Hilltop", "Pear"]
      ]
    },
    {
      id: 2,
      name: "Panel 2",
      topKeys: ["Teco", "Am", "With", "Baby"],
      keys: [
        ["Taco", "Peas", "Good", "KeepAway", "Happy", "Shoe", "Clay", "Noodles",
         "Duane", "Now", "Dessert", "Mirror", "Bowl", "Shop", "Coconut", "Towel"],
        ["Later", "Hammer", "Bad", "Ted", "Rob", "Camera", "TVTape", "Mad",
         "Fight", "Trash", "Hot", "Cold", "Sugar", "Bunny", "Pomegranate", "Downstairs"],
        ["Soap", "Onion", "Nails", "Lighter", "Cereal", "ToolRoom", "Jon",
         "Away", "Slap", "Salt", "ObservationRoom", "Yesterday", "Perrier",
         "Honeysuckle", "Mushroom", "Strawberries"],
        ["Paper", "Give", "Tamuli", "Paint", "Monster", "Potato", "In",
         "LeafTree", "Kiwi", "Pillow", "Chicken", "Grapes", "Privet", "Panzee",
         "Pinky", "Yogurt"],
        ["Sponge", "Oil", "Bubbles", "Sparkler", "Hat", "Phone", "Push", "Out", "River",
         "Jello", "Lana", "Backpack", "KoolAid", "Wipies", "Noise", "Popsicle"],
        ["Spoon", "Play", "TRoom", "Vacuum", "Toothbrush", "Cabinet", "Tomorrow", "Wash",
         "SwimmingPool", "Panbanisha", "MiddleTestRoom", "Balloon", "Draw", "Carry",
         "Please", "ThankYou"],
        ["Knife", "Snake", "Nest", "Toothpaste", "Shirt", "On", "Bug", "Off",
         "Blueberry", "Mouth", "Toy", "Fast", "Gorilla", "Vitamin", "Book", "SugarCane"],
        ["Lettuce", "Think", "Quiet", "Pineapple", "PlasticBag", "House", "Scare",
         "Hand", "Head", "Foot", "Tummy", "Bottom", "Easy", "Throw", "Slow", "Big"]
      ]
    },
    {
      id: 3,
      name: "Panel 3",
      topKeys: ["Jared"],
      keys: [
        ["I", "Brush", "Said", "edPast", "Ear", "Can", "Broken", "Swelling", "For",
         "Sick", "New", "All", "Secret", "Ing", "Fish", "Break"],
        ["Mine", "Clippers", "Bathroom", "Until", "Medicine", "A", "See", "Different",
         "Will", "Work", "Picture", "Puzzle", "Do", "Stop", "Mask", "Here"],
        ["PSuke", "Like", "Ready", "Chalk", "Pretend", "Close", "Take", "More", "Tea",
         "Need", "Nyota", "The", "That", "Say", "Joystick", "Run"],
        ["What", "Kiss", "Time", "Vegetable", "Little", "Down", "It", "Is", "Same",
         "Careful", "Agree", "Sit", "And", "There", "Make", "Sorry"],
        ["Right", "Be", "Crayon", "Feel", "Touch", "ElectricShock", "Put", "Point",
         "Some", "Are", "Show", "Squirrel", "Thing", "Walk", "This", "How"],
        ["Elikya", "Night", "Pour", "Not", "Listen", "Visitors", "Watermelon",
         "Candy", "Box", "Was", "Wrong", "Then", "PluralS", "Today", "Where", "Many"],
        ["We", "Before", "Me", "Blackboard", "Back", "Marshmallow", "Eat",
         "Wait", "Drink", "If", "Red", "Yellow", "Place", "These", "Bird", "Color"],
        ["Want", "Cooler", "Count", "Your", "Piece", "Fruit", "Up", "To",
         "Try", "Arm", "Had", "Blue", "Green", "Have", "My", "You"]
      ]
    }
  ];


  const BonoboHopeKeyboard = ({ octave = 0 }) => {
    const [activePanel, setActivePanel] = useState(1);
    const [sentenceKeys, setSentenceKeys] = useState([]);
    const keyDirectory = "/Keys";
  
    // Initialize sound object with sprites
	const [octaveShift, setOctaveShift] = useState(10);
    const [sound, setSound] = useState(null);
  	const soundRef = useRef(null); // to keep track of the current Howl instance
	
	// Set up a beep for the system.
	const beep = new Audio('/mp3/Chirp.mp3');

  	useEffect(() => {
		if (octaveShift == null) return;
	  
		// unload old sound if needed
		if (soundRef.current) {
		  soundRef.current.unload();
		}
	  
		const soundFile = new Howl({
		  src: [
				`/mp3/KHS_${octaveShift}.ogg`,
				`/mp3/KHS_${octaveShift}.mp3`
				],
		  sprite: audioSprites,
		  preload: true,
		  onload: () => setSound(soundFile)
		});
	  
		soundRef.current = soundFile;
	  
		return () => {
		  soundFile.unload();
		};
	  }, [octaveShift]);
  
    const playSound = (key) => {
      if (sound && audioSprites[key]) {
        return new Promise((resolve) => {
          const soundId = sound.play(key);
          sound.once('end', resolve, soundId);
        });
      }
      return Promise.resolve();
    };


    const handlePanelSwitch = async (panelNumber) => {
      setActivePanel(panelNumber);
      const panelName = ["Alpha", "Beta", "Gamma"][panelNumber - 1];
      await playSound(panelName);
    };
  
    const handleKeyClick = async (key) => {
      if (sentenceKeys.length < 8) {
        setSentenceKeys(prev => [...prev, key]);
        await playSound(key);
      }
    };
  
    const clearSentence = () => {
      setSentenceKeys([]);
    };
  
    const playSentence = async (index = 0) => {
      if (index < sentenceKeys.length) {
        await playSound(sentenceKeys[index]);
        playSentence(index + 1);
      } else {
        clearSentence();
      }
    };
  
    const currentPanel = panels.find(panel => panel.id === activePanel);
  
    return (
      <div className="keyboard-wrapper">
        <div className="control-panel">
          <div className="control-container">
            {["Alpha", "Beta", "Gamma"].map((panel, index) => (
              <img
                key={panel}
                src={`${keyDirectory}/${panel}${activePanel === index + 1 ? '' : '_2'}.jpg`}
                alt={`${panel} Panel`}
                onClick={() => handlePanelSwitch(index + 1)}
                className={activePanel === index + 1 ? 'active' : ''}
              />
            ))}
            
            <div className="dummyPanel">
              {[...Array(8)].map((_, i) => (
                <img
                  key={i}
                  src={sentenceKeys[i] 
                    ? `${keyDirectory}/${sentenceKeys[i]}.jpg`
                    : `${keyDirectory}/Dummy2.gif`}
                  alt={sentenceKeys[i] || "dummy"}
                  className="sentence-slot"
                />
              ))}
              <img
                src={`${keyDirectory}/Period.jpg`}
                alt="End Sentence"
                onClick={() => playSentence()}
              />
            </div>
          </div>
        </div>
  
        {currentPanel && (
          <div className="panel active">
            <div className="grid-container">
              {[...Array(16 - currentPanel.topKeys.length)].map((_, i) => (
                <div key={`spacer-${i}`} className="grid-item dummy" />
              ))}
              {currentPanel.topKeys.map((key, i) => {

                switch (key.toLowerCase()) {
                  case "one":
                    return (
						<button
						  key={`top-${i}`}
						  className="grid-item"
						  onClick={(e) => {								
							if (e.metaKey || e.altKey) {
							  setOctaveShift(10);
							  beep.play();
							} else {
							  handleKeyClick(key);
							}
						  }}
						>
						  <img
							src={`${keyDirectory}/${key}${sentenceKeys.includes(key) ? '_2' : ''}.jpg`}
							alt={key}
							className={sentenceKeys.includes(key) ? 'active' : ''}
						  />
						</button>
					  );
				  case "two":
						return (
							<button
							  key={`top-${i}`}
							  className="grid-item"
							  onClick={(e) => {
								if (e.metaKey || e.altKey) {
								  setOctaveShift(15);
								  beep.play();
								} else {
								  handleKeyClick(key);
								}
							  }}
							>
							  <img
								src={`${keyDirectory}/${key}${sentenceKeys.includes(key) ? '_2' : ''}.jpg`}
								alt={key}
								className={sentenceKeys.includes(key) ? 'active' : ''}
							  />
							</button>
						  );
					case "three":
                    return (
						<button
						  key={`top-${i}`}
						  className="grid-item"
						  onClick={(e) => {
							if (e.metaKey || e.altKey) {
							  setOctaveShift(20);
							  beep.play();
							} else {
							  handleKeyClick(key);
							}
						  }}
						>
						  <img
							src={`${keyDirectory}/${key}${sentenceKeys.includes(key) ? '_2' : ''}.jpg`}
							alt={key}
							className={sentenceKeys.includes(key) ? 'active' : ''}
						  />
						</button>
					  );
                  case "four":
                    return (
						<button
						  key={`top-${i}`}
						  className="grid-item"
						  onClick={(e) => {
							if (e.metaKey || e.altKey) {
							  setOctaveShift(30);
							  beep.play();
							} else {
							  handleKeyClick(key);
							}
						  }}
						>
						  <img
							src={`${keyDirectory}/${key}${sentenceKeys.includes(key) ? '_2' : ''}.jpg`}
							alt={key}
							className={sentenceKeys.includes(key) ? 'active' : ''}
						  />
						</button>
					  );
                  case "five":
                    return (
						<button
						  key={`top-${i}`}
						  className="grid-item"
						  onClick={(e) => {
							if (e.metaKey || e.altKey) {
							  setOctaveShift(40);
							  beep.play();
							} else {
							  handleKeyClick(key);
							}
						  }}
						>
						  <img
							src={`${keyDirectory}/${key}${sentenceKeys.includes(key) ? '_2' : ''}.jpg`}
							alt={key}
							className={sentenceKeys.includes(key) ? 'active' : ''}
						  />
						</button>
					  );
                  default:
                    return (
						<button
						  key={`top-${i}`}
						  className="grid-item"
						  onClick={() => {
							  handleKeyClick(key);
							}
						  }
						>
						  <img
							src={`${keyDirectory}/${key}${sentenceKeys.includes(key) ? '_2' : ''}.jpg`}
							alt={key}
							className={sentenceKeys.includes(key) ? 'active' : ''}
						  />
						</button>
					  );
        	        }
				})
			}

              {currentPanel.keys.flat().map((key, i) => (
                <button
                  key={`main-${i}`}
                  className="grid-item"
                  onClick={() => handleKeyClick(key)}
                >
                  <img
                    src={`${keyDirectory}/${key}${sentenceKeys.includes(key) ? '_2' : ''}.jpg`}
                    alt={key}
                    className={sentenceKeys.includes(key) ? 'active' : ''}
                  />
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  
  export default BonoboHopeKeyboard;
